import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch'

ReactDOM.render(<App />, document.getElementById('root'));

